import { promiseCatcher } from '@containerApp/promiseCatcher'
import { isIOSContainerApp } from '@util/device'
import { logError } from '@util/logger'

function disableGesturesAndroid(): void {
    try {
        if (window.Bridge?.interfaces?.spaContainer?.disableGestures) {
            return window.Bridge.interfaces.spaContainer.disableGestures()
        }
    } catch (e) {
        logError(e)
    }
}

const disableGesturesIOS = async (): Promise<void> => {
    try {
        if (typeof window === 'undefined' || !window.webkit?.messageHandlers?.spaContainer?.postMessage) {
            return
        }

        window.webkit.messageHandlers.spaContainer.postMessage({ call: 'disableGestures' }).catch(promiseCatcher)
    } catch (e) {
        logError(e)
    }
}

export const disableGestures = async (): Promise<void> => {
    if (isIOSContainerApp()) {
        return disableGesturesIOS()
    }

    return disableGesturesAndroid()
}

const enableGesturesIOS = async (): Promise<void> => {
    try {
        if (typeof window === 'undefined' || !window.webkit?.messageHandlers?.spaContainer?.postMessage) {
            return
        }

        window.webkit.messageHandlers.spaContainer.postMessage({ call: 'enableGestures' }).catch(promiseCatcher)
    } catch (e) {
        logError(e)
    }
}

function enableGesturesAndroid(): void {
    try {
        if (window.Bridge?.interfaces?.spaContainer?.enableGestures) {
            return window.Bridge.interfaces.spaContainer.enableGestures()
        }
    } catch (e) {
        logError(e)
    }
}

export const enableGestures = async (): Promise<void> => {
    if (isIOSContainerApp()) {
        return enableGesturesIOS()
    }

    return enableGesturesAndroid()
}
